import React from 'react';
import ReactModal from 'react-modal';
import styled from 'styled-components';
import { Row, Col } from './layout';
import { SecondaryButton, PrimaryButton } from './buttons';
import { TextInput } from './input';
import { baseUrl } from '../lib';

const Title = styled.h1`
    margin: 0;
`;
const CloseIconContainer = styled.div`
    cursor: pointer;
`;
export const ModalContent = styled.p`
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 26px;
    margin-bottom: 40px;
    @media(max-width: 560px){
        font-size: 12px;
    }
`;

function Modal({ title, children, isOpen, closeModal, isRequest }){

    return (
        <ReactModal
          isOpen={isOpen}
          onRequestClose={closeModal}
          shouldCloseOnOverlayClick={true}
          shouldFocusAfterRender={false}
          className="Modal"
          overlayClassName="Overlay"
          style={{ ...(isRequest && {content: {top: '33%'}}) }}
        >
          <Row margin="0 0 31px 0" justifyContent="space-between">
            <Col>
                <Title>{title}</Title>
            </Col>
            <Col>
                <CloseIconContainer>
                    <svg width="35px" height="35px" viewBox="0 0 35 35" version="1.1" onClick={closeModal}>
                        <g id="Icon/close/2px">
                            <path d="M19.0909 0L0 19.0909L19.0909 0Z" transform="translate(7.954545 7.954545)" id="Path-3-Copy-4" fill="none" stroke="#FFFFFF" strokeWidth="2" />
                            <path d="M19.0909 19.0909L0 0L19.0909 19.0909Z" transform="translate(7.954545 7.954545)" id="Path-3-Copy-5" fill="none" stroke="#FFFFFF" strokeWidth="2" />
                        </g>
                    </svg>
                </CloseIconContainer>
            </Col>
          </Row>
          { children }
        </ReactModal>
    )
}

export default Modal;

export const ExitDraftModal = ({ isOpen, handleModalOpen, handleSaveModalOpen, isResults, userCanSave}) => {
    return (
        <Modal title="Quit the draft?" isOpen={isOpen} closeModal={() => handleModalOpen(false)}>
            <Row>
                <ModalContent>
                    {isResults ? (userCanSave ? 'You can save your draft results or exit without saving to discard your draft.' : 'Are you sure you want to exit? If you didn’t share your results they will be lost. Sign up to save your future mock drafts!') : 'Your progress will be lost, are you sure you want to exit ?'}
                </ModalContent>
            </Row>
            <Row justifyContent="space-between">
                {(isResults && userCanSave) && <PrimaryButton onClick={()=> {handleModalOpen(false); handleSaveModalOpen(true);}}>Save & exit</PrimaryButton>}
                <SecondaryButton padding="10px 50px" onClick={() => window.location.replace(baseUrl)}>Exit</SecondaryButton>
            </Row>
        </Modal>
    );
}

export const ExitRankingsModal = ({ isOpen, handleModalOpen, handleSaveModalOpen, userCanSave}) => {
    return (
        <Modal title="Quit the rankings builder?" isOpen={isOpen} closeModal={() => handleModalOpen(false)}>
            <Row>
                <ModalContent>
                    {userCanSave ? 'You can save your rankings in their current position or exit without saving to discard your current rankings.' :
                    'Your progress will be lost, are you sure you want to exit ?'}
                </ModalContent>
            </Row>
            <Row justifyContent='space-between'>
                {userCanSave && <PrimaryButton onClick={()=> {handleModalOpen(false); handleSaveModalOpen(true);}}>Save & Exit</PrimaryButton>}
                <SecondaryButton padding="10px 50px" onClick={() => window.location.replace(baseUrl)}>{userCanSave ? 'Exit without saving' : 'Exit'}</SecondaryButton>
            </Row>
        </Modal>
    );
}

export const RestartDraftModal = ({ isOpen, dispatch, restartDraft, handleModalOpen }) =>{

    return (
        <Modal title="Restart the draft?" isOpen={isOpen} closeModal={() => handleModalOpen(false)}>
            <Row>
                <ModalContent>
                    Your draft progress will be lost, are you sure you want to restart ?
                </ModalContent>
            </Row>
            <Row>
                <SecondaryButton padding="10px 50px" onClick={() => dispatch(restartDraft())}>Restart</SecondaryButton>
            </Row>
        </Modal>
    );
}

export const SaveItemModal = ({ isOpen, item, saveItem, handleModalOpen, title, submitting, setTitle }) =>{
    return (
        <Modal title={`Save your ${item}`} isOpen={isOpen} closeModal={() => handleModalOpen(false)}>
            <Row>
                <TextInput margin="0 0 50px 0" width="90%" placeholder={`Enter a title for your ${item}`} value={title} onChange={(e)=>setTitle(e.target.value)} />
            </Row>
            <Row>
                <PrimaryButton padding="10px 50px" onClick={saveItem} disabled={!title.length || submitting}>Save</PrimaryButton>
            </Row>
        </Modal>
    );
}

export const DeleteItemModal = ({ isOpen, item, handleDeleteItem, handleModalOpen, disabled }) => {
    return (
        <Modal title={`Delete your ${item}`} isOpen={isOpen} closeModal={() => handleModalOpen(false)}>
            <Row>
                <ModalContent>
                    {`Are you sure you want to delete this ${item} ?`}
                </ModalContent>
            </Row>
            <Row justifyContent="space-between">
                <PrimaryButton padding="10px 50px" onClick={handleDeleteItem} disabled={disabled}>Confirm</PrimaryButton>
                <SecondaryButton padding="10px 50px" onClick={() => handleModalOpen(false)}>Cancel</SecondaryButton>
            </Row>
        </Modal>
    );
}